<template>
	<ui-card
		icon="fal fa-clock"
		title="Regras de Ociosidade"
		text="Defina as regras de ociosidade dos seus clientes."
		design="w-50"
	>
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<ui-idleness-rules-table v-model="table" :name="name" />
			</div>
		</template>
		<template #fl></template>
		<template #fr
			><ui-button design="md primary" :disabled="!canSubmit" @click="addRule"
				>Criar Regra
			</ui-button></template
		>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'
	import { uiIdlenessRulesTable } from '@/components/ui-facilita/rules'

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		components: {
			uiCard,
			uiButton,
			uiLoadIndicator,
			uiLoadSuccess,
			uiIdlenessRulesTable,
		},
		data() {
			return {
				name: 'idleness-rules-table',
				table: {},
				loader: { ...defaultLoader() },
			}
		},

		computed: {
			canSubmit() {
				return !this.table.loader && this.table.canSubmit
			},
		},

		methods: {
			async addRule() {
				this.$root.$emit(`modal-open-${this.name}-modal`)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
